// @flow
import React from 'react';
import type { Node } from 'react';

type CellProps = {
  /**
   * The size of this row or column. Accepts any valid {@link
   * https://developer.mozilla.org/en-US/docs/Web/CSS/grid-template-columns
   * CSS Grid row or template size value}
   */
  // eslint-disable-next-line react/no-unused-prop-types
  size: string,
  children: Node,
};

/**
 * Utility component that allows Grid children to declare their own size.
 * See README or the Grid component for usage details.
 */
export default function Cell({ children }: CellProps) {
  const childArr = React.Children.toArray(children);
  if (childArr.length === 1 && React.isValidElement(childArr[0])) {
    return children;
  }
  return <div>{children}</div>;
}

window.$RefreshReg$ = () => {};
window.$RefreshSig$ = () => () => {};
